module.exports = __webpack_public_path__ + "static/media/criteria-8.1.ec2696a2.jpg";